import Vue from 'vue'
import VueRouter from 'vue-router'

import Episode from '@/components/Episode'
import BestOf from '@/components/BestOf'
import Index from '@/components/Index'
import AdminMain from '@/components/admin/AdminMain'
// import AdminLogin from '@/components/admin/AdminLogin'
import AddTopic from '@/components/admin/AddTopic'
import EditEpisodeMeta from '@/components/admin/EditEpisodeMeta'

// import firebase from 'firebase'

Vue.use(VueRouter);

let router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/dummy/topic/add', name: 'Admin - Add topic', component: AddTopic, meta: {requiresAuth: true}},
        {path: '/dummy/episode/edit-meta', name: 'Admin - Edit episode meta', component: EditEpisodeMeta, meta: {requiresAuth: true}},
        // {path: '/login', name: 'Admin - Login', component: AdminLogin, meta: {isLogin: true}},
        {path: '/dummy', name: 'Admin - Main', component: AdminMain, meta: {requiresAuth: true}},

        {path: '/episode/:episode_nr', name: 'Episode', component: Episode},
        {path: '/best-of', name: 'Best of', component: BestOf},
        {path: '*', name: 'Forsíða', component: Index}
    ]
});
/*
router.beforeEach((to, from, next) => {
    console.info(to);
    let currentUser = firebase.auth().currentUser;
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    // let isLogin = to.matched.some(record => record.meta.isLogin);

    if (requiresAuth && !currentUser) {
        next('login');
    }
    else if (!requiresAuth && currentUser) {
        next('admin');
    }
    else {
        next();
    }
});
*/

export default router



// WEBPACK FOOTER //
// ./src/router/index.js